import React, {useContext, useCallback} from "react"
import NewNote from '../../../Notes/ObjectNotes/NewObjectNote'
import NoteList from '../../../Notes/ObjectNotes/ObjectNotesList'
import { GET_DEAL_NOTES, CREATE_NOTE, DEAL_UPDATE_NOTE } from './Queries'
import { isNullArray } from "../../../common/helpers"
import { DispatchContext } from "../../../store"
import { severity } from "../../../Snackbar/CustomizedSnackbar"
import { withApollo } from "@apollo/client/react/hoc"
import NoteSearch from "../../../Search/NoteSearch"
import { DEAL_NOTE_TYPE } from "../../../Notes/ObjectNotes/constants"

function DealNotes(props) {

	const [notes, setNotes] = React.useState([])
	const [notesLoading, setNotesLoading] = React.useState(true)

	//Snackbar
	const dispatch = useContext(DispatchContext)
	const openSnackbar = useCallback((severity, text) => {
		dispatch({ type: 'openSnackBar', payload: { severity, text }})
	}, [dispatch])
	
	// Modal
	const [editNoteModal, setEditNoteModal] = React.useState({open: false, note: null})

	React.useEffect(() => {

		let active = true
		if (!props.findMode && props.id > 0){
			setNotesLoading(true)
			setNotes([])
			
			props.client
				.query({ query: GET_DEAL_NOTES, variables: { deal_id: props.id}})
				.then(notesData => {
					if (active) {
						setNotesLoading(false)
						if (notesData?.data && !isNullArray(notesData?.data?.getDealNotes)) {
							setNotes(notesData?.data.getDealNotes || [])
						} else if (isNullArray(notesData?.data?.getDealNotes)) {
							setNotes([])
							openSnackbar(severity.ERROR, "Error - Unauthorized")
						}
					}
				})
		}
		return () => active = false
	}, [openSnackbar, props.client, props.findMode, props.id])

	return (
		<section className="main-page">
			{props.findMode ? 
				<NoteSearch type="deal" /> :
				<div>
					<NewNote
						entityId={props.id}
						notes={notes}
						setNotes={setNotes}
						notesLoading={notesLoading}
						mutation={CREATE_NOTE}
						mutationName="createDealNote"
						linkField="deal_id"
						state={props.state}
						setState={props.setState}
						criticalNotes="getCriticalDealNotes"
						privateEntity={props.state?.getDeal?.is_private || false}
						noteType={DEAL_NOTE_TYPE}
					/>
					<NoteList
						editNoteModal={editNoteModal}
						setEditNoteModal={setEditNoteModal}
						state={props.state}
						setState={props.setState}
						notes={notes}
						setNotes={setNotes}
						notesLoading={notesLoading}
						mutationResponse="updateDealNote"
						updateMutationName={DEAL_UPDATE_NOTE}
						criticalNotes="getCriticalDealNotes"
						linkField="deal_id"
						privateEntity={props.state?.getDeal?.is_private || false}
					/>
				
				</div>
			}
		</section>
	)
}

export default withApollo(DealNotes)
